/* global importName */
import store from '@/services/store'
import { getDeepProperty } from '@/helpers/deepObject.js'

const AdPreview = () => importName('@/scenes/Episodes/scenes/AdPreview/AdPreview.vue', 'adPreview')
const EpisodeLayout = () => importName('@/scenes/Episodes/EpisodeLayout.vue', 'showLayout')
const EpisodeList = () => importName('@/scenes/Episodes/scenes/EpisodeList/EpisodeList.vue', 'episodeList')
const NewEpisode = () => importName('@/scenes/Episodes/scenes/NewEpisode/NewEpisode.vue', 'newEpisode')
const ShowLayout = () => importName('@/scenes/Shows/ShowLayout.vue', 'showLayout')
const Transcript = () => importName('@/scenes/Episodes/scenes/Transcript/Transcript.vue', 'episodeTranscript')
const ViewEpisode = () => importName('@/scenes/Episodes/scenes/ViewEpisode/ViewEpisode.vue', 'viewEpisode')

const episodeRoutes = [
  {
    path: 'episodes',
    component: ShowLayout,
    children: [
      {
        path: '',
        name: 'episodes',
        props: true,
        component: EpisodeList,
        meta: {
          breadcrumbs: [
            { title: 'Episodes' }
          ]
        },
        beforeEnter: async (to, from, next) => {
          // making sure we wait, mostly to prevent accidently
          // hitting a page before episode is cleared out
          store.dispatch('clearEpisode').then(response => {
            store.dispatch('clearMarkers')
            next()
          })
        }
      },
      {
        path: 'new',
        name: 'create-episode',
        component: NewEpisode,
        props: {
          default: true,
          isNewEpisode: true
        },
        meta: {
          breadcrumbs: [
            { title: 'Episodes', to: 'episodes' },
            { title: 'New Episode' }
          ]
        },
        beforeEnter: async (to, from, next) => {
          // making sure we wait, mostly to prevent accidently
          // hitting new episode page before episode is cleared out
          store.dispatch('clearEpisode').then(response => {
            store.dispatch('clearMarkers')
            next()
          })
        }
      },
      {
        path: ':episodeId',
        component: EpisodeLayout,
        children: [
          {
            path: '',
            name: 'view-episode',
            component: ViewEpisode,
            props: true,
            meta: {
              breadcrumbs: [
                { title: 'Episodes', to: 'episodes' }
                // episode crumb is inserted here by the component
              ]
            }
          },
          {
            path: 'edit',
            name: 'edit-episode',
            component: NewEpisode,
            props: true,
            meta: {
              breadcrumbs: [
                { title: 'Episodes', to: 'episodes' },
                // episode crumb is inserted here by the component
                { title: 'Edit' }
              ]
            }
          },
          {
            path: 'duplicate',
            name: 'duplicate-episode',
            component: NewEpisode,
            props: {
              default: true,
              isDuplicate: true,
              isNewEpisode: true
            },
            meta: {
              breadcrumbs: [
                { title: 'Episodes', to: 'episodes' },
                // episode crumb is inserted here by the component
                { title: 'Duplicate Episode' }
              ]
            }
          },
          {
            path: 'transcript',
            name: 'episode-transcript',
            component: Transcript,
            props: true,
            meta: {
              breadcrumbs: [
                { title: 'Episodes', to: 'episodes' },
                // episode crumb is inserted here by the component
                { title: 'Transcript' }
              ]
            }
          },
          {
            path: 'ad-preview',
            name: 'episode-ad-preview',
            component: AdPreview,
            props: true,
            meta: {
              breadcrumbs: [
                { title: 'Episodes', to: 'episodes' },
                // episode crumb is inserted here by the component
                { title: 'Ad Preview' }
              ]
            },
            beforeEnter: async (to, from, next) => {
              // if a user doesn't have access to "Calisto" (S+) no ad preview pages for them!
              const currentAccount = store.getters.currentAccount
              const adPreview = getDeepProperty(store.getters.featureFlags, 'ad_preview_20220207') && getDeepProperty(currentAccount, 'features.has_calisto')
              if (!adPreview) {
                next({
                  name: 'view-episode',
                  params: {
                    episodeId: getDeepProperty(to, 'params.episodeId'),
                    podcastId: getDeepProperty(to, 'params.podcastId'),
                    accountId: getDeepProperty(to, 'params.accountId')
                  }
                })
                return
              }
              next()
            }
          }
        ],
        beforeEnter: async (to, from, next) => {
          let toEpisodeId = getDeepProperty(to, 'params.episodeId')
          store.dispatch('clearEpisode').then(response => {
            store.dispatch('clearMarkers')
            store.dispatch('getEpisode', toEpisodeId)
            next()
          })
        }
      }
    ],
    beforeEnter: async (to, from, next) => {
      // if a user is not allowed to edit episodes, no episode pages for them!
      let activePodcastUserPermissions = store.getters.activePodcastUserPermissions
      const canEdit = getDeepProperty(activePodcastUserPermissions, 'can_edit')
      if (!canEdit) {
        next({
          name: 'show-overview'
        })
        return
      }
      next()
    }
  }
]

export default episodeRoutes
